var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import cs from 'classnames';
import { Box } from 'ui-kit/box';
import { Icon } from 'ui-kit/icon';
import { HamburgerMenuIcon } from 'common/icons';
import { useSidebarActions } from 'common/layouts/main-layout/service/sidebar-service/hooks';
import styles from './hamburger-button.modules.scss';
export var HamburgerButton = function (_a) {
    var className = _a.className;
    var toggleIsPinnedMenu = useSidebarActions().toggleIsPinnedMenu;
    return (_jsx(Box, __assign({ className: cs(styles.hamburgerButton, className), onClick: function () { return toggleIsPinnedMenu(); } }, { children: _jsx(Icon, { component: HamburgerMenuIcon }) })));
};
